import React, { useState, useEffect }  from "react";
import { Input, Button, Typography, Space, Layout } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const { Title, Paragraph } = Typography;

export const Header = (props) => {
  const location = useLocation();
  const [searchType, setSearchType] = useState('instrument');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    // Set the initial search type based on the location state
    if (location.state && location.state.searchType) {
        setSearchType(location.state.searchType);
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [location.state]);

  const handleSearch = (value) => {
    if (value) {
        if (searchType === 'instrument') {
            const params = new URLSearchParams({
                search: value,
                page: 1,
                query: value,
                city: '',
                state: '',
                postcode: '',
                sort_field: 'name',
                sort_order: 'asc'
            });
            window.location.href=`https://search.searten.com/search-results?${params.toString()}`;
        } 
    }
};

  return (
    <header id="header">
      <div className="intro intro-light">
        <div className="container">
          <div className="row">
            <div className="intro-text">
              <Title
                level={1}
                className="hero-headline"
                style={{
                  color: '#3b6bef',
                  fontSize: isMobile ? '2.4rem' : '3.75rem',
                  fontWeight: 800,
                  marginTop: 0,
                  marginBottom: '16px',
                  lineHeight: 1.1,
                }}
              >
                Find Research Infrastructure
              </Title>
              <Paragraph
                style={{
                  color: '#5b6472',
                  fontSize: isMobile ? '1rem' : '1.15rem',
                  marginBottom: '32px',
                }}
              >
                Discover world-class research instruments and facilities across Australia
              </Paragraph>
              <Input.Search
                placeholder="Search for instruments, techniques, or organisations..."
                allowClear
                enterButton={
                  <Button type="primary" icon={<SearchOutlined />}>
                    {isMobile ? null : 'Search'}
                  </Button>
                }
                size="large"
                onSearch={handleSearch}
                style={{
                  width: '100%',
                  maxWidth: '720px',
                  height: '60px',
                  fontSize: '1.1rem',
                }}
              />
              {/* For the visitor who has landed, does not know the name of the
                  instrument they need, and is looking at an empty field. That
                  is who browsing by capability is for, and this is where they
                  are looking. */}
              <div style={{ marginTop: '18px' }}>
                <a
                  href="https://search.searten.com/browse"
                  style={{
                    color: '#3b6bef',
                    fontWeight: 600,
                    fontSize: isMobile ? '0.95rem' : '1.05rem',
                  }}
                >
                  Or browse by capability
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
